var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskRecordAllTaskCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 22,
    viewBox: "0 0 38 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 24,
    height: 22,
    rx: 11,
    fill: "#D5E6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3346 5.33331H22.0013C21.2649 5.33331 20.668 5.93027 20.668 6.66665V17.3333C20.668 18.0697 21.2649 18.6666 22.0013 18.6666H30.0013C30.7377 18.6666 31.3346 18.0697 31.3346 17.3333V9.33331L27.3346 5.33331Z",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.332 5.33331V9.33331H31.332",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6654 12.6667H23.332",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6654 15.3333H23.332",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 10H23.9987H23.332",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    rx: 11,
    fill: "#CBF1D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33203 10.6667C5.33203 9.56212 6.22746 8.66669 7.33203 8.66669H16.6654C17.7699 8.66669 18.6654 9.56212 18.6654 10.6667V16C18.6654 17.1046 17.7699 18 16.6654 18H7.33203C6.22746 18 5.33203 17.1046 5.33203 16V10.6667Z",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 18V7.33333C14.6654 6.59695 14.0684 6 13.332 6H10.6654C9.92898 6 9.33203 6.59695 9.33203 7.33333V18",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskRecordAllTaskCompleted);
export default __webpack_public_path__ + "static/media/task-record-all-task-completed.9023da60664005078fb87fd04849f734.svg";
export { ForwardRef as ReactComponent };